import { render, staticRenderFns } from "./MapViewConstructor.vue?vue&type=template&id=2f009f45"
import script from "./MapViewConstructor.vue?vue&type=script&lang=js"
export * from "./MapViewConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f009f45')) {
      api.createRecord('2f009f45', component.options)
    } else {
      api.reload('2f009f45', component.options)
    }
    module.hot.accept("./MapViewConstructor.vue?vue&type=template&id=2f009f45", function () {
      api.rerender('2f009f45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/map-view-constructor/MapViewConstructor.vue"
export default component.exports